import React from 'react';

export const OpenBlank = (props) => (
    <svg 
        viewBox="0 0 15 15" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path 
            d="M5.44832 1.14343H1.99902C1.44674 1.14343 0.999023 1.59115 0.999023 2.14343V12.8634C0.999023 13.4157 1.44674 13.8634 1.99902 13.8634H12.719C13.2713 13.8634 13.719 13.4157 13.719 12.8634V9.14453M13.719 1.14343V6.67248M13.719 1.14343L7.36636 7.49609M13.719 1.14343H8.17291" 
            stroke="black"
        />
    </svg>
)